import { Theme, ButtonProps } from "@mui/material";

import commonComponents from "@app/common/theme/components";

const MuiChip = (theme: Theme) => ({
  styleOverrides: {
    root: {
      borderRadius: "8px",
    },
    label: {
      fontFamily: theme.typography.bodySecondaryReg.fontFamily,
    },
  },
});

const MuiMobileStepper = (theme: Theme) => ({
  styleOverrides: {
    dot: {
      backgroundColor: "white",
      border: `solid 1px ${theme.palette.shades.neutral[100]}`,
    },
    dotActive: {
      backgroundColor: theme.palette.primary.main,
      border: `solid 1px ${theme.palette.primary.main}`,
    },
  },
});

declare module "@mui/material/Button" {
  interface ButtonPropsVariantOverrides {
    gradient: true;
  }
}

const MuiButton = (theme: Theme) => ({
  styleOverrides: {
    root: ({ ownerState }: { ownerState: ButtonProps }) => ({
      ...(ownerState.variant === "contained" &&
        ownerState.color === "primary" && {
          "&:hover": { backgroundColor: theme.palette.shades.primary[600] },
          "&:active": { backgroundColor: theme.palette.shades.primary[700] },
          "&:disabled": {
            color: theme.palette.shades.neutral[400],
            backgroundColor: theme.palette.shades.neutral[50],
          },
        }),
      ...((ownerState.variant === "outlined" ||
        ownerState.variant === "text") &&
        ownerState.color === "primary" && {
          borderColor: theme.palette.shades.primary[500],
          color: theme.palette.shades.primary[500],
          "&:hover": {
            backgroundColor: theme.palette.shades.secondary[50],
            borderColor: theme.palette.shades.primary[600],
            color: theme.palette.shades.primary[600],
          },
          "&:active": {
            backgroundColor: theme.palette.shades.secondary[100],
            borderColor: theme.palette.shades.primary[700],
            color: theme.palette.shades.primary[700],
          },
        }),
    }),
    startIcon: { marginLeft: "0px" },
  },
  variants: [
    {
      props: { variant: "gradient" },
      style: {
        color: "#FFF",
        background: theme.palette.gradients.read,
        position: "relative",
        zIndex: 1,
        // Have to use a pseudo element to get the gradient to transition
        // otherwise the gradient will disappear when the button is hovered
        "&::before": {
          borderRadius: "8px",
          position: "absolute",
          content: '""',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          background: theme.palette.shades.primary[500],
          zIndex: -1,
          transition: "opacity 0.25s",
          opacity: 0,
        },
        "&:hover::before": {
          opacity: 1,
        },
      },
    },
  ],
});

const components = (theme: Theme) => ({
  components: {
    ...commonComponents,
    MuiChip: MuiChip(theme),
    MuiMobileStepper: MuiMobileStepper(theme),
    MuiButton: MuiButton(theme),
  },
});

export default components;
